const TIME_OPTIONS: Intl.DateTimeFormatOptions = { hour: 'numeric', minute: 'numeric', second: 'numeric' };
export const timeToString = (value?: number) => {
  if (typeof value !== 'number') return '00:00:00';

  return new Intl.DateTimeFormat('ru', TIME_OPTIONS).format(new Date().setHours(0, 0, value, 0));
};
